import React, { useRef, useState } from "react"
import { Message } from "semantic-ui-react"
import BifrostButton from "../../../BifrostElementComponent/BifrostButton/BifrostButton"
import BifrostModal from "../../BifrostModal/BifrostModal"

import FeedBackSurvey from "../../../BifrostCustomerServiceComponents/SurveySparrowComponents/pages/FeedBackSurvey"

const BifrostFeedBackModal = ({ open, toggleFeedbackModal }) => {
	const ref = useRef()
	const [showSuccessIcon, setShowSuccessIcon] = useState(false)
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState(null)

	const submitHandler = async () => {
		const result = await ref.current.handleSubmit()
		if (result === "COMPLETED") {
			setShowSuccessIcon(true)
			setTimeout(() => {
				setShowSuccessIcon(false)
				toggleFeedbackModal(false)
			}, 3000)
		} else {
			console.log("Error")
		}
	}

	const cancelHandler = () => {
		setShowSuccessIcon(false)
		toggleFeedbackModal(false)
	}

	return (
		<>
			<BifrostModal
				title={"Feedback"}
				open={open}
				setOpen={toggleFeedbackModal}
				modalPage={
					showSuccessIcon ? (
						<Message success size="large" style={{ textAlign: "center" }} icon="check circle outline" content="Thank you for your feedback!" />
					) : (
						<FeedBackSurvey ref={ref} setIsLoading={setIsLoading} setError={setError} />
					)
				}
				modalActions={
					<>
						<BifrostButton type="submit" style={{ display: "inline-block" }} onClick={() => submitHandler()} disabled={isLoading || error || error === "" || showSuccessIcon}>
							Submit
						</BifrostButton>

						<BifrostButton style={{ display: "inline-block" }} onClick={() => cancelHandler()} color="gray" disabled={isLoading}>
							{!showSuccessIcon ? <>Cancel</> : <>Close</>}
						</BifrostButton>
					</>
				}
			/>
		</>
	)
}

BifrostFeedBackModal.propTypes = {}

export default BifrostFeedBackModal
